import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='text-5xl relative top-52 text-white'>Not found</h1>
        </div>
    );
};

export default NotFound;